import React, { Component } from 'react';
import { stylesheet } from 'astroturf/react';
import { throttle } from 'lodash';

// @ts-expect-error ts-migrate(2306) FIXME: File '/home/ubuntu/code/academia-app/app/assets/ja... Remove this comment to see the full error message
import scribd from 'js/scribd_api/scribd_api';

const SCRIBD_CONTAINER_ID = 'scribd-reflowable-doc';

type Props = {
  children?: React.ReactNode;
  attachmentId?: number;
  scrollParent?: HTMLElement;
};

export default class ScribdDocumentView extends Component<Props> {
  container?: HTMLElement;
  scribdInitialized = false;
  throttledResizeListener: () => void = () => {};

  handleResize: ResizeObserverCallback = throttle((entries) => {
    entries.forEach((e: ResizeObserverEntry) => {
      if (e.target === this.container) {
        if (!this.scribdInitialized) {
          this.setupScribd();
        } else {
          this.resizeScribd();
        }
      }
    });
  }, 16);
  resizeObserver = new ResizeObserver(this.handleResize);
  zoomPerPixel?: number;
  scribdDoc?: any;

  componentDidMount() {
    if (this.container) {
      if (this.container.offsetWidth > 0) this.setupScribd();
      this.resizeObserver.observe(this.container);
    }
  }

  componentWillUnmount() {
    this.resizeObserver.disconnect();
  }

  setupScribd() {
    const { attachmentId, scrollParent } = this.props;
    this.scribdDoc = scribd.Document.getDoc(attachmentId, scrollParent);
    this.scribdDoc.addParam('jsapi_version', 2);
    this.scribdDoc.addParam('disable_related_docs', true);
    this.scribdDoc.addParam('disable_resume_reading', true);
    this.scribdDoc.addParam('hideZoomControls', true);

    this.scribdDoc.addEventListener('docReady', () => {
      // Prevent Scribd from explicitly setting document.body's width
      Object.getPrototypeOf(
        this.scribdDoc.docManager,
      ).constructor.updateBodyWidth = false;

      const firstPage = document.querySelector<HTMLElement>('.outer_page');
      if (firstPage) {
        const initialScribdWidth = firstPage.offsetWidth;
        this.zoomPerPixel = 1 / initialScribdWidth;
        this.resizeScribd();
      }
    });

    this.scribdDoc.seamless(SCRIBD_CONTAINER_ID);

    this.scribdInitialized = true;
  }

  resizeScribd() {
    if (this.container == null || this.zoomPerPixel == null) {
      return;
    }
    const calculatedZoom = this.zoomPerPixel * this.container.offsetWidth;

    // this is a hack to prevent `setZoom` changing the scroll position
    const currentSrcoll = [window.pageXOffset, window.pageYOffset];
    this.scribdDoc.api.setZoom(calculatedZoom);
    window.scrollTo(currentSrcoll[0], currentSrcoll[1]);
  }

  render() {
    return (
      <div
        id={SCRIBD_CONTAINER_ID}
        ref={(node) => node && (this.container = node)}
      >
        {this.props.children || 'PDF Loading'}
      </div>
    );
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const styles = stylesheet`
  :global {
    #${SCRIBD_CONTAINER_ID} {
      .outer_page_container > .outer_page {
        margin: 0 auto 10px;
        position: relative;

        & > .newpage {
          overflow: hidden;
        }

        & > #jpedal {
          overflow: hidden;
        }

        /* Give each page a white background and a bit of box shadow */
        &:before {
          content: ' ';
          position: absolute;
          background: white;
          box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }

        /* Hide crazy scribd image box shadow */
        .b_tl,
        .b_tr,
        .b_br,
        .b_bl,
        .b_t,
        .b_r,
        .b_b,
        .b_l {
          display: none;
        }
      }
    }

    /* Hide scribd page up/down + zoom in/out + fullscreen controls */
    #scribd_pager {
      display: none;
    }
  }
`;
